function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".8",
  d: "M12.9 2.52l-.03.07-2.9 6.73H7.12c-.68 0-1.32.13-1.92.39l1.75-4.18.04-.09.06-.16c.03-.07.05-.13.08-.18 1.31-3.03 2.79-3.72 5.77-2.58z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.29 9.52c-.45-.13-.92-.2-1.41-.2H9.97l2.9-6.73.03-.07c.14.05.29.12.44.17l2.21.93c1.23.51 2.09 1.04 2.62 1.68.09.12.17.23.25.36.09.14.16.28.2.43.04.09.07.17.09.26.26.85.1 1.88-.42 3.17z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.76 14.2v1.95c0 .2-.01.4-.02.59-.19 3.5-2.14 5.26-5.84 5.26H8.1c-.25 0-.48-.02-.71-.05-3.18-.21-4.88-1.91-5.1-5.09-.03-.24-.05-.47-.05-.71V14.2c0-2.01 1.22-3.74 2.96-4.49.6-.26 1.24-.39 1.92-.39h9.76c.49 0 .96.07 1.41.2a4.9 4.9 0 013.47 4.68z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M6.95 5.53L5.2 9.71a4.894 4.894 0 00-2.96 4.49v-2.93c0-2.84 2.02-5.21 4.71-5.74zm14.81 5.74v2.93a4.9 4.9 0 00-3.47-4.68c.52-1.29.68-2.32.42-3.17-.02-.09-.05-.17-.09-.26a5.84 5.84 0 013.14 5.18z"
})));